// Product tabs (PDP)   
const tabs = document.querySelectorAll('.product-tabs__navigation-btn');
const tabsContent = document.querySelectorAll('.product-tabs__body');

if (tabsContent.length > 0 || tabs.length > 0) {

  function hideTabContent() {
    tabsContent.forEach(item => {
      item.classList.remove('active');
    });

    tabs.forEach(item => {
      item.classList.remove('active');
    });
  }

  function showTabContent(i = 0) {
    tabsContent[i].classList.add('active');
    tabs[i].classList.add('active');
  }

  hideTabContent();
  showTabContent();

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      hideTabContent();
      showTabContent(index);
    });
  });
}